var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"header"}},[_c('Header')],1),_vm._v(" "),_c('router-view',{attrs:{"id":"main"}}),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }